<template>
  <div class="claims">
    <div class="map-info-header">
      <div>
        <div class="location">{{ currentLocation?.name }}</div>
        <div class="role top">{{ props.shift?.portal_role_name }}</div>
        <div class="date bottom">{{ formatDate(props.shift?.start_at) }}</div>
      </div>
      <div class="right">
        <div class="value top">
          £{{ toRawCurrency(props.shift?.client_rate * props.shift?.hours, props.shift?.currency) }}
        </div>
        <div class="bottom">{{ formatTimeRange(props.shift?.start_at, props.shift?.end_at) }}</div>
      </div>
    </div>
    <GroupTag
      :locationId="props.shift?.location_id"
      :group-id="props.shift?.group_id"
      :group-type="props.shift?.group_type"
      :role-name="props.shift?.group_external_role_name"
    ></GroupTag>
    <div class="map-container">
      <l-map
        class="map"
        :zoom="zoom"
        :options="{
          zoomControl: false,
          dragging: false,
          scrollWheelZoom: false,
          doubleClickZoom: false,
          boxZoom: false,
          touchZoom: false,
          attributionControl: false,
        }"
        :inertiaDeceleration="400"
        :center="centerLatLong"
        :attributionControl="false"
      >
        <l-tile-layer :url="url"></l-tile-layer>
        <l-marker :zIndexOffset="999" v-if="currentLocation" :lat-lng="[props.shift?.latitude, props.shift?.longitude]">
          <l-icon class-name="location-marker">
            <img :src="currentLocation.properties.logo_url" class="location-logo" />
          </l-icon>
        </l-marker>
        <l-marker
          v-for="claim in props.claims"
          :key="'map-' + claim.claim_id"
          @click="onClaimSelected(claim.claim_id)"
          :lat-lng="[claim?.worker_latitude, claim?.worker_longitude]"
        >
          <l-icon class-name="claim-marker">
            <div :class="['headline', { selected: props.selectedClaimId === claim.claim_id }]">
              <!-- <svg v-if="props.selectedClaimId === claim.claim_id" width="17" height="16" viewBox="0 0 17 16"
                fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M8.5 14.5C12.0899 14.5 15 11.5899 15 8C15 4.41015 12.0899 1.5 8.5 1.5C4.91015 1.5 2 4.41015 2 8C2 11.5899 4.91015 14.5 8.5 14.5ZM12.0017 5.87648C12.2771 6.16508 12.2663 6.62224 11.9777 6.89757L8.00322 10.6892C7.724 10.9556 7.2847 10.9554 7.00571 10.6888L5.02186 8.79298C4.73349 8.5174 4.72312 8.06024 4.99869 7.77186C5.27427 7.4835 5.73144 7.47312 6.01981 7.7487L7.50511 9.1681L10.9806 5.85244C11.2692 5.57711 11.7264 5.58787 12.0017 5.87648Z"
                  fill="#8F5DE7" />
              </svg> -->

              <span class="name">{{ truncateText(claim.worker_name.split(' ')[0], 8) }}</span>
              <!-- <svg class="arrow" width="22" height="31" viewBox="0 0 22 31" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M11 0C4.93154 0 0 4.76792 0 10.6348C0 12.6199 0.568456 14.552 1.65006 16.2181L10.2543 29.8314C10.4011 30.0618 10.6211 30.2037 10.8778 30.2391C11.2261 30.2923 11.6112 30.1505 11.8128 29.8138L20.4417 16.0762C21.4683 14.4456 22 12.5491 22 10.6348C22 4.76792 17.0685 0 11 0Z"
                  fill="#8F5DE7" />
                <path
                  d="M11 0C11 9.67771 11 18.6549 11 30.2498C11.3128 30.2568 11.6345 30.1118 11.8128 29.814L20.4417 16.0764C21.4683 14.4458 22 12.5492 22 10.6349C22 4.76797 17.0685 0 11 0Z"
                  fill="black" fill-opacity="0.15" />
              </svg> -->
            </div>
            <div class="point"></div>
          </l-icon>
        </l-marker>
      </l-map>
    </div>
    <header>
      <svg width="24" height="24" class="mr-1" viewBox="0 0 18 23" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M13.75 7.76138V4.875C13.75 4.1125 13.4471 3.38124 12.9079 2.84207C12.3688 2.3029 11.6375 2 10.875 2C10.4883 2 10.1096 2.07791 9.75999 2.22502C9.6176 1.89876 9.41452 1.59866 9.15793 1.34207C8.61876 0.802901 7.8875 0.5 7.125 0.5C6.3625 0.5 5.63124 0.802901 5.09207 1.34207C4.5529 1.88124 4.25 2.6125 4.25 3.375V3.63638C3.96968 3.54681 3.67475 3.5 3.375 3.5C2.6125 3.5 1.88124 3.8029 1.34207 4.34207C0.802901 4.88124 0.5 5.6125 0.5 6.375V14.25C0.5 16.5043 1.39553 18.6663 2.98959 20.2604C4.58365 21.8545 6.74566 22.75 9 22.75C11.2543 22.75 13.4163 21.8545 15.0104 20.2604C16.6045 18.6663 17.5 16.5043 17.5 14.25V10.5C17.5 9.7375 17.1971 9.00624 16.6579 8.46707C16.1188 7.9279 15.3875 7.625 14.625 7.625C14.3252 7.625 14.0303 7.67181 13.75 7.76138ZM7.125 2.5C6.89294 2.5 6.67038 2.59219 6.50628 2.75628C6.34219 2.92038 6.25 3.14294 6.25 3.375V10.5C6.25 11.0523 5.80228 11.5 5.25 11.5C4.69772 11.5 4.25 11.0523 4.25 10.5V6.375C4.25 6.14294 4.15781 5.92038 3.99372 5.75628C3.82962 5.59219 3.60706 5.5 3.375 5.5C3.14294 5.5 2.92038 5.59219 2.75628 5.75628C2.59219 5.92038 2.5 6.14294 2.5 6.375V14.25C2.5 15.9739 3.18482 17.6272 4.40381 18.8462C5.62279 20.0652 7.27609 20.75 9 20.75C10.7239 20.75 12.3772 20.0652 13.5962 18.8462C14.8152 17.6272 15.5 15.9739 15.5 14.25V10.5C15.5 10.2679 15.4078 10.0454 15.2437 9.88128C15.0796 9.71719 14.8571 9.625 14.625 9.625C14.3929 9.625 14.1704 9.71719 14.0063 9.88128C13.8422 10.0454 13.75 10.2679 13.75 10.5V12.375C13.75 12.9273 13.3023 13.375 12.75 13.375C12.0207 13.375 11.3212 13.6647 10.8055 14.1805C10.2897 14.6962 10 15.3957 10 16.125C10 16.6773 9.55229 17.125 9 17.125C8.44772 17.125 8 16.6773 8 16.125C8 14.8652 8.50044 13.657 9.39124 12.7662C10.0425 12.115 10.8634 11.6724 11.75 11.4814V4.875C11.75 4.64294 11.6578 4.42038 11.4937 4.25628C11.3296 4.09219 11.1071 4 10.875 4C10.6429 4 10.4204 4.09219 10.2563 4.25628C10.0922 4.42038 10 4.64294 10 4.875V9.75C10 10.3023 9.55228 10.75 9 10.75C8.44772 10.75 8 10.3023 8 9.75V3.375C8 3.14294 7.90781 2.92038 7.74372 2.75628C7.57962 2.59219 7.35706 2.5 7.125 2.5Z"
          fill="currentColor"
        />
      </svg>
      <span>
        {{ props.claims.length }}
        {{ candidateText }}
      </span>
    </header>
    <div class="claims-list">
      <EmployeeCard
        v-for="claim in props.claims"
        @mouseover="hoveredClaim = claim.claim_id"
        @mouseleave="hoveredClaim = null"
        :key="claim.claim_id"
        :claim="claim"
        :selected="props.selectedClaimId === claim.claim_id"
        :roles="props.shift?.portal_role_name"
        @claimSelected="onClaimSelected(claim.claim_id)"
        :shift="props.shift"
        :show-full-profile="true"
      />
    </div>
  </div>
</template>

<script setup>
import GroupTag from '@/pages/talent-pool/shift/components/GroupTag.vue';
import EmployeeCard from '@/pages/talent-pool/components/EmployeeCard.vue';
import useTalentPoolLocations from '@/state/composables/useTalentPoolLocations';
import { useRoute } from 'vue-router/composables';
import { computed, onBeforeMount, ref } from 'vue';
import { LMap, LTileLayer, LMarker, LIcon } from 'vue2-leaflet';
import 'leaflet/dist/leaflet.css';
import { formatDate, formatTimeRange } from '@/pages/talent-pool/utils/datetime';
import { toRawCurrency } from '@/utils';
import { truncateText } from '@/pages/talent-pool/utils/text';

const url = process.env.VUE_APP_MAPBOX_MAP_URL + `?access_token=${process.env.VUE_APP_MAPBOX_API_KEY}`;
const zoom = 10;

const { locations, getLocations } = useTalentPoolLocations();

const props = defineProps(['shift', 'claims', 'selectedClaimId']);

const emit = defineEmits(['claim-selected']);

const route = useRoute();
const locationId = route.params.locationId;

const hoveredClaim = ref(null);

const candidateText = computed(() => {
  if (props.shift?.group_type === 'job_posting') {
    return props.claims.length === 1
      ? 'candidate you selected is interested'
      : 'candidates you selected are interested';
  }
  return props.claims.length === 1 ? 'person is interested' : 'people are interested';
});

const centerLatLong = computed(() => {
  if (props.selectedClaimId) {
    const claim = props.claims.find(claim => claim.claim_id === props.selectedClaimId);
    return [claim.worker_latitude, claim.worker_longitude];
  }
  if (hoveredClaim.value) {
    const claim = props.claims.find(claim => claim.claim_id === hoveredClaim.value);
    return [claim.worker_latitude, claim.worker_longitude];
  }
  if (props.shift) {
    return [props.shift.latitude, props.shift.longitude];
  }
  return [0, 0];
});

const currentLocation = computed(() => {
  if (locations.value.length > 0) {
    return locations.value.find(location => location.location_id === locationId);
  }
  return null;
});

const onClaimSelected = claimId => {
  emit('claim-selected', claimId);
};

onBeforeMount(() => {
  getLocations();
});
</script>

<style scoped lang="scss">
.claims header {
  font-size: 22px;
  font-weight: 400;
  padding: 0.5rem 0;
  display: flex;
  align-items: center;
  margin-bottom: 0.9rem;
}

.claims .claims-list {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
}

@media (max-width: 900px) {
  .claims .claims-list {
    grid-template-columns: repeat(2, 1fr);
  }
}

.map-info-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.85rem;
}

.map-info-header div {
  display: flex;
  flex-direction: column;
}

.map-info-header div.right {
  align-items: flex-end;
}

.map-info-header .location {
  font-size: 14px;
  line-height: 20px;
  letter-spacing: -0.01em;
  color: var(--palette-color-default-lighten-20);
  margin-bottom: 4px;
}

.map-info-header .top {
  font-size: 22px;
  font-weight: 400;
}

.map-info-header .bottom {
  font-size: 14px;
  line-height: 20px;
  letter-spacing: -0.01em;
  text-align: left;
  color: var(--palette-color-default);
}

.map-container {
  height: 275px;
  margin: 1rem 0;
  background-color: var(--palette-color-default-lighten-90);
  border-radius: 4px;
  overflow: hidden;
  border: 1px solid var(--palette-color-default-lighten-90);
}

.map {
  height: 100%;
}

// .claim-marker .headline {
//   background-color: var(--palette-color-base-white);
//   width: 84px;
//   padding: 2px 8px;
//   border-radius: 99px;
//   display: flex;
//   justify-content: center;
//   border: 2px solid var(--palette-color-default-lighten-20);
//   font-size: 13px;
//   font-weight: 500;
//   line-height: 18px;
//   letter-spacing: -0.01em;
//   text-align: center;
//   align-items: center;
//   gap: .3rem;
//   position: relative;
// }

.claim-marker {
  width: auto !important;
}

.claim-marker .point {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: var(--palette-color-default-lighten-20);
}

.claim-marker .headline {
  background-color: var(--palette-color-base-white);
  padding: 0.5rem;
  border-radius: 0.5rem;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  height: 36px;
  width: 84px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-left: -38px;
  margin-bottom: 3px;
  border: 2px solid var(--palette-color-default-lighten-90);
}

.claim-marker .name {
  font-size: 13px;
  font-weight: 600;
  line-height: 18px;
  letter-spacing: -0.01em;
  text-align: center;
  text-transform: capitalize;
}

// .claim-marker .arrow {
//   position: absolute;
//   bottom: -18px;
//   z-index: -1;
// }

.claim-marker .headline.selected {
  // background-color: var(--palette-color-brand-primary-lighten-20);
  // color: var(--palette-color-brand-primary);
  border: 2px solid var(--palette-color-default);
}

.location-marker .location-logo {
  height: 40px;
  width: 40px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid var(--palette-color-default-lighten-20);
  background-color: var(--palette-color-base-white);
}
</style>
